import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentFactory
} from "@angular/core";
import { ModalComponent } from "ng2-bs3-modal";
import { IxsReportComponent } from "../ixs-report/ixs-report.component";
import { SyncValue } from "../../core/service/syncdata.service";

@Component({
  selector: "ixs-printviewer",
  templateUrl: "ixs-printviewer.component.html"
})
export class IxsPrintviewerComponent {
  @ViewChild("printViewer") public printViewer: ModalComponent;
  @ViewChild("report", { read: ViewContainerRef }) container;
  componentRef: any;
  private reportTitle = "";

  constructor(private resolver: ComponentFactoryResolver) {}

  public async openReport(
    reportCode: string,
    reportTitle: string,
    showCriteria: boolean,
    isCollapsed: boolean,
    defaultValues: Array<SyncValue>,
    isAutoGenerated:boolean = true
  ) {
    this.reportTitle = reportTitle;
    this.container.clear();
    const factory: ComponentFactory<
      any
    > = this.resolver.resolveComponentFactory(IxsReportComponent);
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.defaultValues = defaultValues;
    this.componentRef.instance.isAutoGenerated = isAutoGenerated;
    this.componentRef.instance.reportCode = reportCode;
    this.componentRef.instance.isCollapsed = isCollapsed;
    this.componentRef.instance.showCriteria = showCriteria;
    await this.printViewer.open("lg");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ixs-printviewer/ixs-printviewer.component.ts